/*
 * @Author: shiguang
 * @Date: 2023-04-26 10:50:23
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-05 15:03:49
 * @Description: 路由页面
 */
import { ComponentType, LazyExoticComponent, lazy } from 'react';
import { AppstoreOutlined } from '@ant-design/icons';
import { Outlet, RouteObject } from 'react-router-dom';
import CommonLayout from '@/common/Layout';
import { strings } from '@/i18n/i18n';

export type RouteItem = RouteObject & {
    /**
     * 路由对应的页面
     */
    component?: LazyExoticComponent<ComponentType<any>> | ComponentType<any>;
    /**
     * 路由地址
     */
    path: string;
    /**
     * 父级路由，用于menu的高亮判断，例如 detail 页面 要定位到 列表页面 菜单上
     */
    activePath?: string;
    /**
     * 默认false，如果为true时，需要和路由相同时才能匹配，但是如果有斜杠也是可以匹配上的。
     */
    exact?: boolean;
    /**
     * 是否严格匹配斜杠结尾
     */
    strict?: boolean;
    /**
     * 页面标题
     */
    title?: string;
    /**
     * 图标
     */
    icon?: React.ReactNode;
    layout?: React.FC<any>;
    /**
     * 显示左侧菜单，默认为true
     */
    showMenu?: boolean;
    /**
     * 显示左侧菜单，默认为true
     */
    showSlider?: boolean;
    /**
     * 显示头部，默认为true，如果设为false，则无头部组件
     */
    showHeader?: boolean;
    /** 页面权限code */
    pagePermissionCode?: string;
    /** 操作权限code */
    actionPermissionCode?: string[];
    // 嵌套路由
    children?: RouteItem[];
};

export const ROUTER_BASENAME = '/smc';

const router: RouteItem[] = [
    {
        path: '/manage',
        title: strings.t('推广联盟'),
        icon: <i className="iconfont icon-tuiguanglianmeng_48_48" />,
        layout: CommonLayout,
        children: [
            {
                path: 'MyPromotion',
                title: strings.t('我的推广'),
                component: lazy(() => import('../container/manage/MyPromotion'))
            },
            {
                path: 'RewardDetails',
                title: strings.t('奖励明细'),
                component: lazy(
                    () => import('../container/manage/RewardDetails')
                )
            },
            {
                path: 'promoteWallet',
                title: strings.t('推广钱包'),
                component: lazy(
                    () => import('../container/manage/PromoteWallet')
                )
            }
        ] as RouteItem[]
    },

    {
        path: '/promotion',
        title: strings.t('推广联盟'),
        layout: CommonLayout,
        showSlider: false,
        showMenu: false,
        children: [
            {
                path: 'SelectIdentity',
                title: strings.t('选择推荐者身份'),
                component: lazy(
                    () => import('../container/promotion/SelectIdentity')
                )
            },
            {
                path: 'index',
                title: strings.t('推广联盟介绍'),
                component: lazy(() => import('../container/promotion/Info'))
            }
        ] as RouteItem[]
    },

    {
        path: '/dev/login',
        title: 'dev-login',
        component: lazy(() => import('../container/dev/Login')),
        showMenu: false
    },

    {
        path: '/*',
        title: strings.t('迷失方向'),
        showMenu: false,
        component: function () {
            return <div>{strings.t('您似乎迷失了方向')}~</div>;
        }
    }
];

export default router;
